// dirty.ts
let offscreenDirty = true;

export function markStaticDirty(): void {
  offscreenDirty = true;
}

export function getStaticDirty(): boolean {
  return offscreenDirty;
}

export function setStaticDirty(value: boolean): void {
  offscreenDirty = value;
}